export default "__VITE_ASSET__fwMxbX6K__"